import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'gl-cart-emptied-notification-modal-v2',
    templateUrl: './cart-emptied-notification-modal-v2.component.html'
})
export class CartEmptiedNotificationModalV2Component implements AfterViewInit {
    @ViewChild('focus') focus: ElementRef;
    @Output() closeModal = new EventEmitter<void>();

    ngAfterViewInit() {
        setTimeout(() => this.focus.nativeElement.focus());
    }

    onCloseEndedDialog() {
        this.closeModal.emit();
    }
}
